import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AdvanceRequestFileUploadAdd } from './Pages';

export const AdvanceRequestFileUploadRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={AdvanceRequestFileUploadAdd} />
    </Fragment>
)